import React from "react";
import { Box } from "../design-system";
import { colors } from "../design-system/colors";
import { TABS } from "./constants/accountText";

export enum AccountTab {
  Profile = "profile",
  Subscription = "subscription",
  Usage = "usage",
  Auto = "auto",
}

interface TabConfig {
  id: AccountTab;
  label: string;
}

const TAB_CONFIG: TabConfig[] = [
  { id: AccountTab.Profile, label: TABS.PROFILE },
  { id: AccountTab.Subscription, label: TABS.SUBSCRIPTION },
  { id: AccountTab.Usage, label: TABS.USAGE },
  { id: AccountTab.Auto, label: TABS.AUTO },
];

const TAB_HEIGHT = 35;
const TAB_BORDER_RADIUS = "100px";
const TAB_GAP = "16px";
const TAB_FONT_SIZE = "16px";
const TAB_LINE_HEIGHT = "22px";
const TAB_PADDING = "0 20px";

interface AccountTabNavProps {
  activeTab: AccountTab;
  onTabChange: (tab: AccountTab) => void;
}

const AccountTabNav = ({ activeTab, onTabChange }: AccountTabNavProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: TAB_GAP,
      }}
      role="tablist"
      aria-label="Account settings tabs"
    >
      {TAB_CONFIG.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <Box
            key={tab.id}
            component="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onTabChange(tab.id)}
            sx={{
              height: `${TAB_HEIGHT}px`,
              borderRadius: TAB_BORDER_RADIUS,
              padding: TAB_PADDING,
              backgroundColor: isActive
                ? colors.tab.activeBackground
                : colors.tab.inactiveBackground,
              color: isActive ? colors.neutral.white : colors.neutral[600],
              opacity: isActive ? 1 : 0.8,
              fontSize: TAB_FONT_SIZE,
              lineHeight: TAB_LINE_HEIGHT,
              fontFamily: "Outfit, sans-serif",
              fontWeight: 400,
              border: "none",
              cursor: "pointer",
              whiteSpace: "nowrap",
              transition: "background-color 0.15s ease, color 0.15s ease",
              "&:focus-visible": {
                outline: `2px solid ${colors.primary[500]}`,
                outlineOffset: "2px",
              },
            }}
          >
            {tab.label}
          </Box>
        );
      })}
    </Box>
  );
};

export default AccountTabNav;
